/* eslint-disable indent */
import {
 reactive, ref, watch, toRef,
} from '@vue/composition-api'
import formatDate from '@/utils/date-format'
import { compareArray, compareObj } from './compareHelper'
import { successNotification } from '@/utils/toast-notifications'

export default function useLogs(ctx) {
  const resourceTypeOptions = [
    {
      key: 'trips-configuration',
      label: 'Trips Configuration',
    },

  ]

  const queryParams = reactive({
      resourceType: null,
      resourceId: null,
      page: 1,
      size: 10,
  })

  const showZoneService = ref(false)
  const loading = ref(false)
    const zonesOptions = ref([])
    const servicesOptions = ref([])
    const currZone = ref()
    const currService = ref()
    const setServices = () => {
        servicesOptions.value = currZone?.value.services
  }
  const zonesLoading = ref(false)
    const fetchZones = async () => {
      try {
          zonesLoading.value = true
          zonesOptions.value = await ctx.root.$store.dispatch('zones/fetchZones')
          zonesLoading.value = false
        } catch (error) {
            console.log(error)
        }
  }
  const logs = ref([])
  const tableColumns = [
    {
      key: 'logsCheck',
      label: '',
    },
    {
      key: 'actorId',
      label: 'actor',
    },
    {
      key: 'actorType',
      label: 'actor type',
    },
    {
      key: 'createdAt',
      label: 'created at',
      formatter: val => formatDate(val),
    },
  ]
    const nestedFields = [
    {
      key: 'label',
      label: 'Change in',
    },
    {
      key: 'card',
      label: 'Card',
    },
    {
      key: 'changedKey',
      label: 'Changed field',
    },
    {
      key: 'old',
      label: 'Old value',
    },
      {
      key: 'new',
      label: 'New value',
    },

  ]
  const totalLogs = ref(0)
  const fetchLogs = async () => {
    try {
      loading.value = true
      logs.value = []
            queryParams.resourceId = `${currZone.value.country}::${currZone.value.city}::${currService.value}`
            const res = await ctx.root.$store.dispatch('logs/fetchLogs', queryParams)
      logs.value = res?.data?.data?.data
      totalLogs.value = res?.data?.data?.data?.total
      console.log(res)
            if (!logs.value.length) {
              successNotification('No logs to be shown')
            } else {
              logs.value.forEach(element => {
            const newDetails = element.details.new
            const oldDetails = element.details.old
            const cancellation = compareArray(newDetails.cancellation_reasons, oldDetails.cancellation_reasons)
            const fines = compareArray(newDetails.fines, oldDetails.fines)
            const rules = compareArray(newDetails.rules, oldDetails.rules)
            let driverOffer = null
            if (newDetails.driver_offer && oldDetails.driver_offer) {
              driverOffer = compareObj(newDetails.driver_offer, oldDetails.driver_offer)
            }
              // eslint-disable-next-line no-param-reassign
            element.difference = []
                if (cancellation.length) {
              element.difference.push(...cancellation.map(el => ({ ...el, label: 'Cancellation Reasons' })))
            }
            if (fines.length) {
               element.difference.push(...fines.map(el => ({ ...el, label: 'Fines' })))
            }
            if (rules.length) {
               element.difference.push(...rules.map(el => ({ ...el, label: 'Rules' })))
            }
            if (driverOffer) {
              element.difference.push(...driverOffer.map(el => ({ ...el, label: 'Screen Configurations' })))
            }
              })
              logs.value = logs.value.filter(el => el.difference.length)
            }
    } catch (error) {
      console.log(error)
    } finally {
      loading.value = false
    }
  }
  fetchZones()
  const show = () => {
    showZoneService.value = true
  }
  watch([toRef(queryParams, 'page'), toRef(queryParams, 'size')], () => {
    fetchLogs()
  })
  return {
    fetchLogs,
    fetchZones,
    resourceTypeOptions,
    queryParams,
    zonesOptions,
    currZone,
    currService,
    servicesOptions,
    setServices,
    zonesLoading,
    showZoneService,
    show,
    loading,
    tableColumns,
    logs,
    nestedFields,
    totalLogs,
  }
}
